/**
 * <k-tilt>: leans its child toward the mouse in 3D and moves a soft light sheen.
 * Runs only for fine pointers that can hover, and never when reduced motion is preferred.
 * Writes --rx / --ry (rotation) and --mx / --my (sheen position) custom properties;
 * the visual treatment lives in the `.k-tilt` rules in config/styles.css.
 */
class KTilt extends HTMLElement {
  #frame = 0;

  #onMove = (event) => {
    if (event.pointerType !== 'mouse') return;
    const rect = this.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      this.style.setProperty('--ry', `${(x * 10).toFixed(2)}deg`);
      this.style.setProperty('--rx', `${(-y * 10).toFixed(2)}deg`);
      this.style.setProperty('--mx', `${((x + 0.5) * 100).toFixed(1)}%`);
      this.style.setProperty('--my', `${((y + 0.5) * 100).toFixed(1)}%`);
      this.setAttribute('data-tilting', '');
    });
  };

  #onLeave = () => {
    cancelAnimationFrame(this.#frame);
    this.style.setProperty('--rx', '0deg');
    this.style.setProperty('--ry', '0deg');
    this.removeAttribute('data-tilting');
  };

  connectedCallback() {
    const canTilt = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
    if (!canTilt.matches) return;
    this.addEventListener('pointermove', this.#onMove);
    this.addEventListener('pointerleave', this.#onLeave);
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.#frame);
    this.removeEventListener('pointermove', this.#onMove);
    this.removeEventListener('pointerleave', this.#onLeave);
  }
}

if (!customElements.get('k-tilt')) {
  customElements.define('k-tilt', KTilt);
}
